module.exports = __webpack_public_path__ + "img/U411.04d49c67.png";